export type FertWorkStatus =
  | 'Validating'
  | 'In Progress'
  | 'Complete'
  | 'Error'
  | 'Issues'
  | 'No Data';

export const STATUS_CODES = {
  VALIDATING: 0,
  IN_PROGRESS: 1,
  COMPLETE: 2,
  ERROR: 3,
  ISSUES: 4,
  NO_DATA: 5,
} as const;

export const BLOCKING_ISSUE_TYPES = [
  'MissingSire',
  'MissingAccount',
  'NoOocytes',
  'InvalidMatTime',
] as const;

export const NON_BLOCKING_ISSUE_TYPES = ['MissingShipLabel'] as const;

export type BlockingIssueType = (typeof BLOCKING_ISSUE_TYPES)[number];
export type NonBlockingIssueType = (typeof NON_BLOCKING_ISSUE_TYPES)[number];

export function isBlockingIssue(issueType: string): boolean {
  return BLOCKING_ISSUE_TYPES.includes(issueType as BlockingIssueType);
}

export function getBlockingIssueTranslationKey(issueType: string): string {
  switch (issueType) {
    case 'MissingSire':
      return 'fertWork.missingSire';
    case 'MissingAccount':
      return 'fertWork.missingAccount';
    case 'NoOocytes':
      return 'fertWork.noOocytes';
    case 'InvalidMatTime':
      return 'fertWork.invalidMatTime';
    default:
      return issueType.replace(/([A-Z])/g, ' $1').trim();
  }
}

export function statusCodeToLabel(code: number): FertWorkStatus {
  switch (code) {
    case STATUS_CODES.VALIDATING:
      return 'Validating';
    case STATUS_CODES.IN_PROGRESS:
      return 'In Progress';
    case STATUS_CODES.COMPLETE:
      return 'Complete';
    case STATUS_CODES.ERROR:
      return 'Error';
    case STATUS_CODES.ISSUES:
      return 'Issues';
    case STATUS_CODES.NO_DATA:
      return 'No Data';
    default:
      return 'Validating';
  }
}

export function statusLabelToCode(label: FertWorkStatus): number {
  switch (label) {
    case 'Validating':
      return STATUS_CODES.VALIDATING;
    case 'In Progress':
      return STATUS_CODES.IN_PROGRESS;
    case 'Complete':
      return STATUS_CODES.COMPLETE;
    case 'Error':
      return STATUS_CODES.ERROR;
    case 'Issues':
      return STATUS_CODES.ISSUES;
    case 'No Data':
      return STATUS_CODES.NO_DATA;
    default:
      return STATUS_CODES.VALIDATING;
  }
}
